<template>
    <div class="pflichtproben">
        {{data[prefix + "_active"]}} |
        <span class="text-secondary">{{data[prefix + "_until_now"]}}</span> |
        <template v-if="percentage < 100">
            <span class="text-danger">{{percentage}}%</span>
        </template>
        <template v-else>
            <span class="text-success">{{percentage}}%</span>
        </template>
    </div>
</template>

<script>
import "./Pflichtproben.scss";

export default {
    name: "Pflichtproben",
    props: ["data", "prefix"],
    computed: {
        percentage() {
            if (this.data[this.prefix + '_active'] && this.data[this.prefix + '_until_now']) {
                let percentage = Math.round(100 * this.data[this.prefix + '_active'] / this.data[this.prefix + '_until_now'])
                if (percentage > 100) {
                    return 100;
                }
                return percentage;
            }
            return 0;
        }
    }
};
</script>